export default "__VITE_ASSET__DBl3HNaE__"